import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    position: "relative",
    overflow: "hidden",
  },
  iframe: {
    transformOrigin: "top left",
    border: 0,
  },
}));
